import React, { Component } from 'react'
import { connect } from 'react-redux'
import cx from 'classnames'

import Header from './shared/header'
import Footer from './shared/footer'
import AboutSection from './shared/about-section'
import CookieConsent from './shared/cookie-consent'

class Layout extends Component {

    launchSpecialMode () {

        const canvas = document.createElement('canvas')
        canvas.style.position = 'fixed'
        canvas.style.top = canvas.style.bottom = canvas.style.left = canvas.style.right = '0px'
        canvas.style.zIndex = 1000
        canvas.style.opacity = 0.8

        canvas.width = window.innerWidth
        canvas.height = window.innerHeight

        document.body.appendChild(canvas)

        const ctx = canvas.getContext('2d')

        const img = document.createElement('img')
        img.src = '/gfs_39576_3_1.jpg'

        const pCount = 300
        const particles = new Array(pCount).fill(1).map(a => {
            const r = Math.floor(Math.random() * 255)
            const g = Math.floor(Math.random() * 255)
            const b = Math.floor(Math.random() * 255)
            return {
                x: window.innerWidth / 2,
                y: window.innerHeight,
                vx: (Math.random() * 2 - 1) * 50,
                vy: Math.random() * -50,
                radius: 1 + Math.random() * 10,
                color: `rgb(${r}, ${g}, ${b})`
            }
        })

        let oldTime = 0

        renderFrame()

        function renderFrame () {
            requestAnimationFrame(renderFrame)
            const now = window.performance.now() / 66
            const dt = now - oldTime
            oldTime = now

            ctx.fillStyle = 'rgba(6, 6, 6, 1)'
            ctx.fillRect(0, 0, window.innerWidth, window.innerHeight)

            const gravity = 0.5

            if (img.complete) {
                ctx.drawImage(img, window.innerWidth / 2 - img.width / 2, window.innerHeight / 2 - img.height * 1.5)
            }

            particles.forEach(p => {
                p.x += p.vx * dt
                p.y += p.vy * dt

                p.vy += gravity

                if (p.x > window.innerWidth) {
                    p.x = window.innerWidth 
                    p.vx *= -1
                } else if (p.x < 0) {
                    p.x = 0
                    p.vx *= -1
                } else if (p.y > window.innerHeight + p.radius) {
                    p.x = window.innerWidth / 2
                    p.y = window.innerHeight
                    p.vx = (Math.random() * 2 - 1) * 50
                    p.vy = Math.random() * -50
                }

                ctx.save()
                ctx.fillStyle = p.color
                ctx.translate(p.x, p.y)
                ctx.beginPath()
                ctx.arc(0, 0, p.radius, 0, Math.PI * 2, true)
                ctx.closePath()
                ctx.fill()
                ctx.restore()
            })
            
        }

    }

    componentDidMount () {
        const konamiCodes = [
            38, // arrow up
            38, // arrow up
            40, // arrow down
            40, // arrow down
            37, // arrow left
            39, // arrow right
            37, // arrow left
            39, // arrow right
            66, // B
            65  // A
        ]

        let comboCounter = 0
        let oldTime = 0
        const maxDiff = 1000

        window.addEventListener('keydown', e => {
            
            const now = window.performance.now()
            const diff = now - oldTime
            oldTime = now

            if (diff < maxDiff) {
                comboCounter += 1

                if (comboCounter === konamiCodes.length - 1) {
                    // this.launchSpecialMode()
                }
            } else {
                comboCounter = 0
            }

        }, false)
    }

    render () {

        const {
            pageURL,
            heroUnitScrolled,
            heroUnitScrolledMobile,
            isAboutOpen,
            navOpen,
            navHeight,
            children
        } = this.props

        const style = navOpen ? {
            transform: `translateY(${navHeight}px)`
        } : {}

        const className = cx(
            { scrolled: heroUnitScrolled },
            { scrolledMobile: heroUnitScrolledMobile }
        )

        const containerStyle = isAboutOpen ? { 
            transition: 'transform 0.2s ease-in-out',
            transform: `translate3d(-450px, 0, 0)`
        } : {
            transition: 'transform 0.2s ease-in-out'
        }
        return (
            <div className="layout-container" data-page={pageURL}>
                <AboutSection />
                <Header />
                <div className={className} style={style}>
                    <div style={containerStyle}>
                        {children}
                    </div>
                </div>
                <Footer />
                <CookieConsent />
            </div>
        )
    }
}

export default connect(state => {
    return {
        pageURL: state.router.location.pathname,
        heroUnitScrolled: state.uiReducer.heroUnitScrolled,
        heroUnitScrolledMobile: state.uiReducer.heroUnitScrolledMobile,
        isAboutOpen: state.uiReducer.isAboutOpen,
        navOpen: state.uiReducer.isNavOpen,
        navHeight: state.uiReducer.navHeight
    }
})(Layout)




// WEBPACK FOOTER //
// ./src/components/Layout.jsx